export default __webpack_public_path__ + "static/media/background.ed49f156.jpg";